import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import DescriptionIcon from '@material-ui/icons/Description';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import PersonIcon from '@material-ui/icons/Person';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import podeVerRelatorioTarifas from '../../../../config/relatorioTarifas';
import { IReducer } from '../../../../redux/configureStore';
import Button from '../../../../shared/components/buttons/Button';
import SideButton from '../../../../shared/components/SideMenu/components/SideButtons';
import Text from '../../../../shared/components/Text';
import Wrapper from '../../../../shared/components/Wrapper';
import Tag from '../CashInAppV2/components/Tag';
import Divisor from './components/Divisor';
import {
  ReturnAccountingAppButton,
  ReturnDashboardButton,
  setButtonIsClicked,
} from './functions';
import { ISetters } from './functions/interfaces';
import { IRenderSideMenuButtons } from './interface';

function SideMenuButtons(props: IRenderSideMenuButtons) {
  const dispatch = useDispatch();
  const profileUserContext = useSelector(
    (reducer: IReducer) => reducer.userProfile
  );

  const [dashboardIsClicked, setDashboardIsClicked] = useState(false);
  const [clientsIsClicked, setClientsIsClicked] = useState(false);
  const [faresIsClicked, setFaresIsClicked] = useState(false);
  const [outstandingDebitsIsClicked, setOutstandingDebitsClicked] =
    useState(false);
  const [limitIsClicked, setLimitIsClicked] = useState(false);
  const [accountingIsClicked, setAccountingIsClicked] = useState(false);
  const [apurationIsClicked, setApurationIsClicked] = useState(false);
  const [cashinIsClicked, setCashInIsClicked] = useState(false);
  const [transferIsClicked, setTransferIsClicked] = useState(false);
  const [cashinV2IsClicked, setCashinV2IsClicked] = useState(false);

  const setters: ISetters = {
    dispatch,
    setAppComponent: props.setAppComponent,
    setDashboardIsClicked,
    setClientsIsClicked,
    setFaresIsClicked,
    setOutstandingDebitsClicked,
    setLimitIsClicked,
    setAccountingIsClicked,
    setApurationIsClicked,
    setCashInIsClicked,
    setTransferIsClicked,
    setCashinV2IsClicked,
  };

  return (
    <>
      <ReturnDashboardButton
        onClick={() => {
          setButtonIsClicked('dashboard', setters);
        }}
        wasClicked={dashboardIsClicked}
      />

      <SideButton
        onClick={() => {
          setButtonIsClicked('clients', setters);
        }}
        wasClicked={clientsIsClicked}>
        <PersonIcon />
        <span>Clientes</span>
      </SideButton>

      <SideButton
        onClick={() => {
          setButtonIsClicked('fares', setters);
        }}
        wasClicked={faresIsClicked}>
        <AttachMoneyIcon />
        <span>Tarifas</span>
      </SideButton>

      <SideButton
        onClick={() => {
          setButtonIsClicked('outstanding', setters);
        }}
        wasClicked={outstandingDebitsIsClicked}>
        <PriorityHighIcon />
        <span>Débitos</span>
      </SideButton>

      <SideButton
        onClick={() => {
          setButtonIsClicked('limit', setters);
        }}
        wasClicked={limitIsClicked}>
        <MoneyOffIcon />
        <span>Limites</span>
      </SideButton>

      <ReturnAccountingAppButton
        onClick={() => {
          setButtonIsClicked('accounting', setters);
        }}
        wasClicked={accountingIsClicked}
      />

      <Wrapper.Default isActive width="100%" margin="1.5rem 0 0 0">
        <Text.Span>Relatórios</Text.Span>
        <Divisor.Default />
      </Wrapper.Default>

      {podeVerRelatorioTarifas(profileUserContext.partnerId) && (
        <Button.Default
          onClick={() => {
            setButtonIsClicked('cashInV2', setters);
          }}
          wasClicked={cashinV2IsClicked}
          justifyContent="space-between"
          width="10rem"
          margin="5px 0"
          height="3.5rem">
          <MoneyOffIcon />
          <span
            style={{
              display: 'inline-flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
              gap: '3px',
              maxWidth: '6.5rem',
              lineHeight: 1.1,
              textAlign: 'right',
            }}>
            <span style={{ fontSize: '0.8rem', fontWeight: 600 }}>
              Relatórios de Tarifas
            </span>
            <Tag>Novo</Tag>
          </span>
        </Button.Default>
      )}

      {profileUserContext.partnerId === 1 && (
        <>
          <SideButton
            onClick={() => {
              setButtonIsClicked('apuration', setters);
            }}
            wasClicked={apurationIsClicked}>
            <DescriptionIcon />
            <Text.Span>Apuração Contas</Text.Span>
          </SideButton>

          <SideButton
            onClick={() => {
              setButtonIsClicked('transfer', setters);
            }}
            wasClicked={transferIsClicked}>
            <DescriptionIcon />
            <Text.Span>Transferência</Text.Span>
          </SideButton>
        </>
      )}
      <SideButton
        onClick={() => {
          setButtonIsClicked('cashIn', setters);
        }}
        wasClicked={cashinIsClicked}>
        <MoneyOffIcon />
        <span>Tarifas de Recebimento</span>
      </SideButton>
    </>
  );
}

export default SideMenuButtons;
